var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"messageImage"}},[_vm._m(0),_c('File',{style:({width: '660px', height: '450px', marginLeft: 0, marginTop: '13px'}),attrs:{"bg":'var(--color-pri)',"folder":'message',"defaultValue":_vm.defaultValue},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messtitle"},[_c('div',[_vm._v("純圖片訊息 ")]),_vm._v(" "),_c('span')])
}]

export { render, staticRenderFns }